// buffet — see README.md. Keys must exist in BOTH maps (checked by npm run check:locales).
export const en = {
  // --- Full-screen floor plan ----------------------------------------------
  'buffet.plan.apply': 'Save plan',
  'buffet.plan.discardTitle': 'Discard these floor-plan changes?',
  'buffet.plan.discardBody': 'The tables you moved and the stations you placed in this window are thrown away. The saved plan stays as it was.',
  'buffet.plan.discardConfirm': 'Discard changes',
  'buffet.plan.keepEditing': 'Keep editing',
  'buffet.plan.previewHint': 'Preview — open Expand to move tables and place dishes.',
  'buffet.plan.expand': 'Expand',
  'buffet.plan.collapse': 'Close',
  'buffet.plan.fullTitle': 'Floor plan & dish stations',
  'buffet.plan.fullHint': 'Drag a table to move it; click a dish on the right to put it on the floor. Nothing is kept until you press Save plan.',
  // --- The two-phase wizard shell ------------------------------------------
  'buffet.wiz.phase1': 'Buffet setup',
  'buffet.wiz.phase2': 'Advance settings',
  'buffet.wiz.lockedHint': 'Save the buffet first — there is nothing to configure advanced settings against until it exists.',
  'buffet.wiz.subStepOf': 'Setup {n} of {total}',
  'buffet.wiz.toAdvance': 'Advance settings',
  'buffet.wiz.saveToContinue': 'Save & continue',

  // --- The run calendar down the left of setup -----------------------------
  'buffet.cal.title': 'Dates it runs on',
  'buffet.cal.sub': '{n} day(s) will be opened when you save.',
  'buffet.cal.empty': 'No dates chosen yet.',
  'buffet.cal.emptyHint': 'Set a first and last date in Name, dates & sittings and the days appear here.',
  'buffet.cal.emptyHintSaved': 'This buffet is not on any date yet. Set a first and last date in Name, dates & sittings, or open it on a day from Open Buffets.',
  'buffet.cal.legendOpened': 'Already open',
  'buffet.cal.legendRunning': 'Being served',
  'buffet.cal.dayOpened': 'Already open on this day — guests can book it.',
  'buffet.cal.dayRunning': 'Being served right now.',
  'buffet.cal.countOpened': 'days already open',
  'buffet.cal.legendHoliday': 'Holiday',
  'buffet.cal.noHolidays': 'No holidays or festivals fall in this range.',
  'buffet.cal.holidaysUnavailable': 'The holiday calendar could not be loaded, so holidays are not marked here.',
  'buffet.cal.legendObservance': 'Observance',
  'buffet.cal.observance': 'observed',
  'buffet.cal.approxMark': '±1 day',
  'buffet.cal.approxHint': 'Confirmed locally close to the day, so it can move by one.',
  'buffet.cal.legendWeekend': 'Weekend',
  'buffet.cal.holidaysInRange': 'Holidays in this range ({n})',
  'buffet.cal.publicHoliday': 'public',
  'buffet.cal.legendPlanned': 'Planned',
  'buffet.cal.legendSet': 'Set',
  'buffet.cal.dayPlanned': 'Planned — saving the buffet is what opens this day.',
  'buffet.cal.daySet': 'The buffet is set on this day.',
  'buffet.cal.daySkipped': 'Taken out of the run — click to put it back.',
  'buffet.cal.dayCloses': 'Open now — closes on Save, no longer in the rule',
  'buffet.cal.notYetOpened': 'Not opened yet — saving the buffet is what puts it on these days.',

  // --- Month view (Open Buffets) -------------------------------------------
  'buffet.month.prev': 'Previous month',
  'buffet.month.next': 'Next month',
  'buffet.month.expand': 'Expand the calendar',
  'buffet.month.shrink': 'Shrink the calendar',
  'buffet.month.jumpToday': 'Jump to today',
  'buffet.month.willOpen': 'Will open when this repeat is saved',
  'buffet.month.legendOpen': 'Open ({n})',
  'buffet.month.legendLive': 'Running now ({n})',
  'buffet.month.legendRepeat': 'This repeat ({n})',

  // --- Planner calendar chrome (shared by every buffet calendar) -----------
  'buffet.cal.countOpen': 'days open',
  'buffet.cal.countHolidays': 'holidays',
  'buffet.cal.countWeekends': 'weekends',
  'buffet.cal.legendToday': 'Today',
  'buffet.cal.range': '{from} – {to}',

  // --- Step 2: advance settings -------------------------------------------
  'buffet.adv.intro': 'Optional depth on top of the buffet you have just set up. Advance pricing is live; the other two areas are being built — the buffet works without any of them.',
  'buffet.adv.comingSoon': 'Nothing to set here yet.',
  'buffet.adv.pricing.title': 'Advance pricing settings',
  'buffet.adv.pricing.blurb': 'The days that are not ordinary. What each holiday and each weekend actually drew at this branch over the last few years, and how much more than step 1’s price to charge on them.',

  // Advance pricing: the footfall tables, and the uplift they lead to.
  'buffet.adv.hol.title': 'Holidays inside this run',
  'buffet.adv.hol.blurb': 'What each one drew here over the last {n} years — on the date it actually fell on, since most of them move. Tick the ones worth charging more for.',
  'buffet.adv.we.title': 'Weekends inside this run',
  // The two doors on the pricing area, and the way back out of one.
  'buffet.adv.hol.inRun': '{n} inside this run',
  'buffet.adv.we.inRun': '{n} Saturdays and Sundays inside this run',
  'buffet.adv.pricedN': '{n} priced',
  'buffet.adv.nonePriced': 'Nothing priced yet',
  'buffet.adv.backToCards': 'Back to advance pricing',
  'buffet.adv.closeCard': 'Close',
  'buffet.adv.we.blurb': 'The same question asked of Saturdays and Sundays: what an average one drew here in each of the last {n} years.',
  'buffet.adv.baseline': 'An ordinary weekday feeds about {n} guests here, over {days} days of trade.',
  'buffet.adv.baselineNone': 'There is not enough past trade to say what an ordinary day looks like here, so the figures below stand on their own.',
  'buffet.adv.baseIs': 'Step 1 charges {price} a head.',
  'buffet.adv.noBase': 'Set an adult price on the Pricing step to see what these become.',
  'buffet.adv.colHoliday': 'Holiday',
  'buffet.adv.colWeekend': 'Day',
  'buffet.adv.colAvg': '{n}-year average',
  'buffet.adv.colUplift': 'Charge on the day',
  'buffet.adv.moves': 'moves each year',
  'buffet.adv.publicHoliday': 'public holiday',
  'buffet.adv.observance': 'observance',
  'buffet.adv.noFigures': 'no figures',
  'buffet.adv.notObserved': 'not observed',
  'buffet.adv.vsOrdinary': '{pct} vs an ordinary day',
  'buffet.adv.inRange': '{n} in this run',
  'buffet.adv.daysMeasured': '{n} days',
  // Under each year's figure: the diary's own numbers, which is how a
  // manager recognises a day - "14 bookings" lands where a bare 41 does not.
  'buffet.adv.bookingsN': '{n} bookings',
  'buffet.adv.soldN': '{n} sold at the till',
  'buffet.adv.bulkLead': 'Raise the ticked rows by',
  'buffet.adv.apply': 'Apply to {n} ticked',
  'buffet.adv.clearAll': 'Clear every uplift',
  'buffet.adv.clearOne': 'Charge the ordinary price on this day',
  'buffet.adv.tickAll': 'Tick every row',
  'buffet.adv.modePct': 'A percentage change on the normal price',
  'buffet.adv.modeSet': 'A new fixed price for this day, in place of the normal one',
  /* The normal price is printed FIRST on every row: it is what a % is a %
     of and what a new price replaces, and switching between the two
     converts the figure rather than re-reading 10 as ten rupees. */
  'buffet.adv.newPrice': 'New price',
  'buffet.adv.normalIs': 'Normal price {price}',
  'buffet.adv.normalUnset': 'No normal price yet — set the adult price on the Pricing step',
  'buffet.adv.wasPrice': 'was {price}',
  'buffet.adv.onNormal': 'on {price}',
  'buffet.adv.bulkLeadSet': 'Set the ticked rows to',
  'buffet.adv.upliftLabel': 'How much more',
  'buffet.adv.summary': '{n} uplifts are set. They are saved as this buffet’s pricing rules, so the till, the booking page and every quote charge them on the day.',
  'buffet.adv.loading': 'Reading the last {n} years…',
  'buffet.adv.failed': 'Past footfall could not be read, so the tables below have no history in them. The uplifts still work — you are setting them on judgement rather than on figures.',
  'buffet.adv.noHolidays': 'No holidays fall inside this run.',
  'buffet.adv.needDates': 'Set the run dates on step 1, and the holidays and weekends inside them are listed here with what they have drawn before.',
  'buffet.adv.fixedWarn': 'Fixed pricing is on, so no rule can move the price — anything set here is saved but never charged.',
  'buffet.adv.useDynamic': 'Switch to dynamic pricing',
  'buffet.adv.stacks': 'It falls on a {day}, so that uplift is charged on top of this one.',
  'buffet.adv.dow.5': 'Saturday',
  'buffet.adv.dow.6': 'Sunday',
  'buffet.adv.menu.title': 'Advance menu selection settings',
  'buffet.adv.menu.blurb': 'What a guest may choose when they book ahead — which spreads are offered, and how far in advance the choice is locked for the kitchen.',
  'buffet.adv.capacity.title': 'Advance capacity settings',
  'buffet.adv.capacity.blurb': 'How much of the room advance bookings may take — seats held back for walk-ins, and per-sitting release rules.',

  // --- Step 1: which dates the buffet should be opened on ------------------
  // The range is an instruction, not a stored property of the template: saving
  // carries it out by creating the openings, and Open Buffets stays the one
  // place that knows which days a buffet runs.
  'buffet.dates.label': 'Dates it runs on',
  'buffet.dates.from': 'First date',
  'buffet.dates.to': 'Last date',
  'buffet.dates.hint': 'Optional — leave blank to save the template now and put it on dates later from Open Buffets.',
  // How the run is shaped: a span, the weekdays inside it, and days struck out.
  'buffet.dates.willOpenOf': 'Saving will open this buffet on {n} of the {span} day(s) in that range.',
  'buffet.dates.noneLeft': 'Nothing would open — every day in that range is skipped.',
  'buffet.dates.runFor': 'Run for',
  'buffet.dates.preset.week': '1 week',
  'buffet.dates.preset.fortnight': '2 weeks',
  'buffet.dates.preset.month': '1 month',
  'buffet.dates.preset.quarter': '3 months',
  'buffet.dates.preset.halfYear': '6 months',
  'buffet.dates.onDays': 'Runs on these days',
  'buffet.dates.everyDay': 'Every day',
  'buffet.dates.noWeekends': 'No weekends',
  'buffet.dates.weekendsOnly': 'Weekends only',
  // Monday first, matching the calendar grid and the server's own numbering.
  'buffet.dates.dow.0': 'Mon',
  'buffet.dates.dow.1': 'Tue',
  'buffet.dates.dow.2': 'Wed',
  'buffet.dates.dow.3': 'Thu',
  'buffet.dates.dow.4': 'Fri',
  'buffet.dates.dow.5': 'Sat',
  'buffet.dates.dow.6': 'Sun',
  'buffet.dates.skipHolidays': 'Skip the {n} public holiday(s) in this range',
  'buffet.dates.skipped': '{n} date(s) skipped',
  'buffet.dates.clearSkipped': 'Put them all back',
  'buffet.dates.putBack': 'Put this date back',
  'buffet.dates.clickHint': 'Click any day on the calendar to take it out of the run, or to put it back.',
  'buffet.dates.savedNotOpened': 'The buffet was saved, but those dates could not be opened: {error}',
  'buffet.dates.partlyOpened': 'The buffet was saved and opened on {opened} of {total} day(s). The rest could not be opened: {error}',
  /* The rule reaches days ALREADY open: struck weekdays and dates close on
     Save. Said beside the chips first, then reported after. */
  'buffet.dates.willClose': 'Saving will also close {n} already-open day(s) that these days no longer cover.',
  'buffet.dates.cantClose': '{n} of them stay open — served, or being served right now.',
  'buffet.dates.someKept': 'The buffet was saved and {closed} day(s) closed, but {kept} could not be: {error}',
  'buffet.del.button': 'Delete',
  'buffet.del.title': 'Remove this template for good — only possible while it has never sold a cover or run a service',
  'buffet.del.titleLive': 'Being served right now — close the service before deleting it',
  'buffet.del.confirmTitle': 'Delete "{name}"?',
  'buffet.del.confirmBody': 'The template, its spread and its prices are removed for good. This cannot be undone.',
  'buffet.del.confirmWithDates': 'The template, its spread and its prices are removed for good, along with the {n} date(s) it is open on. This cannot be undone.',
  'buffet.del.confirmCta': 'Delete for good',
  'buffet.del.runningTitle': 'It is being served right now',
  'buffet.del.runningBody': '"{name}" has guests at the counter. Close the service first, then it can be deleted.',
  'buffet.del.failedTitle': 'Could not delete it',
  'buffet.del.failedBody': 'The buffet was not deleted.',

  // --- Step 4: what each sitting charges -----------------------------------
  'buffet.slotPrice.title': 'Price per sitting',
  'buffet.slotPrice.titleFixed': 'Fixed price for each sitting',
  'buffet.slotPrice.hint': 'One row per sitting from step 1. Every sitting starts at the buffet’s own per-head price above — retype a row and that sitting sells at its own price instead. Empty a box to hand it back to the buffet price.',
  'buffet.slotPrice.noSlots': 'No sittings yet. Turn Sittings on in step 1 to price them one by one.',
  /* Sitting map: what the picked areas actually seat. Per sitting AND
     across the day, because the room turns over. */
  'buffet.seatmap.perSitting': '{seats} guests a sitting',
  'buffet.seatmap.acrossSittings': '{total} across {n} sittings',
  'buffet.seatmap.enough': 'enough for the {covers} planned',
  'buffet.seatmap.short': 'short of the {covers} planned',
  'buffet.slotPrice.slotOff': 'not sold',
  /* The right-hand column no longer names a MODE, it names a figure: what a
     guest actually hands over for this sitting, tax and all. A price a
     manager can read straight off the row is the whole point of the table. */
  'buffet.slotPrice.colCharges': 'Guest pays',
  'buffet.slotPrice.ownTag': 'own price',
  'buffet.slotPrice.kidsShort': 'kids {price}',
  'buffet.slotPrice.taxIncl': 'incl. {names}',
  'buffet.slotPrice.taxPlus': 'plus {names}',
  'buffet.slotPrice.dynamicNote': 'These are the figures each sitting starts from. Dynamic pricing rules may still move them — choose Fixed price above to charge them exactly as typed.',

  // --- Step 4: tax on the ticket -------------------------------------------
  'buffet.tax.title': 'Tax on the ticket',
  'buffet.tax.excl': 'Price excludes tax',
  'buffet.tax.incl': 'Price includes tax',
  'buffet.tax.exclNote': 'The prices above are what you keep — the tax is added on top and the guest pays more.',
  'buffet.tax.inclNote': 'The prices above are what the guest pays — the tax is already inside them and is broken out on the bill.',
  'buffet.tax.pickIncl': 'Which tax is already inside the price?',
  'buffet.tax.pickExcl': 'Which tax is added on top?',
  'buffet.tax.compound': '(compound)',
  'buffet.tax.noneTicked': 'No tax ticked — the per-head prices above are charged exactly as they stand.',
  'buffet.tax.noRates': 'No tax rates are set up for this restaurant yet, so there is nothing to tick.',
  'buffet.tax.setUp': 'Set up tax rates →',
  'buffet.tax.adultPays': 'One adult pays',
  'buffet.tax.kidPays': 'One kid pays',
  'buffet.tax.breakdown': '= {net} + {tax} tax',
  'buffet.tax.rulesCarry': 'Prices set by pricing rules carry the same taxes.',

  /* Sittings: the serving window sold as repeating start times (studio step 1)
     and picked by the guest on the reservation page. */
  'buffet.sit.title': 'Sittings',
  'buffet.sit.hint': 'Sell this window as one service, or as a start time every so many minutes.',
  'buffet.sit.one': 'One service',
  'buffet.sit.many': 'Sittings',
  'buffet.sit.gap': 'A sitting starts every',
  'buffet.sit.length': 'and lasts',
  'buffet.sit.min': '{n} min',
  'buffet.sit.hr': '{n} h',
  'buffet.sit.count': '{n} sittings a day, {first} to {last}.',
  'buffet.sit.none': 'A {n}-minute sitting does not fit between {from} and {to} — shorten the sitting, or widen the serving window.',
  'buffet.sit.colTime': 'Sitting',
  'buffet.sit.colAdult': 'Adult price',
  'buffet.sit.colChild': 'Child price',
  'buffet.sit.colSeats': 'Seats',
  'buffet.sit.colOn': 'Served',
  'buffet.sit.anySeats': "Day's covers",
  'buffet.sit.turnOff': 'Not served',
  'buffet.sit.turnOn': 'Serve this one',
  'buffet.sit.blankHint': "Left blank, a sitting is sold at the buffet's own price and draws on the day's covers.",

  /* Step 1 owns the day's guest numbers; step 2 splits them over the sittings. */
  'buffet.guests.title': 'Guests',
  'buffet.guests.adults': 'Adults',
  'buffet.guests.children': 'Children',
  'buffet.guests.covers': 'Expected covers',

  /* Guest-facing: picking which sitting to book. */
  'buffet.sit.pick': 'Choose your sitting',
  'buffet.sit.pickHint': 'Each sitting is a table for the whole time shown.',
  'buffet.sit.full': 'Fully booked',
  'buffet.sit.seatsLeft': '{n} seats left',
  'buffet.sit.seatLeft': '1 seat left',
  'buffet.sit.perAdult': '/adult',

  /* Buffet planning calendar — every day resolved from the rule stack. */
  'plan.list.title': 'Buffet planner',
  'plan.list.sub': 'One plan over a long range, bent by rules — no day is configured twice.',
  'plan.list.loading': 'Loading plans...',
  'plan.list.rules': '{n} rule(s)',
  'plan.list.emptyTitle': 'No plans yet',
  'plan.list.emptyBody': 'Your buffets are still running exactly as they were — nothing here has stopped them. A plan is the new way to configure one: a single plan over a long range, bent by rules, instead of a record for every day. Bringing this branch’s buffets across is a one-off move your RestoBOXX administrator makes for you, because every price rule has to be read and checked by a person first. Until then, carry on in the Buffet List.',
  'plan.list.emptyCta': 'Go to the Buffet List',
  'plan.calendar.title': 'Buffet planner',
  'plan.calendar.sub': 'Every day computed from the plan and its rules.',
  'plan.calendar.runs': 'Runs {range}. Nothing is stored per day — change a rule and every day follows.',
  'plan.calendar.back': 'Back',
  'plan.calendar.prev': 'Previous month',
  'plan.calendar.next': 'Next month',
  'plan.calendar.closed': 'Closed',
  'plan.calendar.covers': '{n} covers',
  'plan.calendar.noHistory': 'No history',
  'plan.rules.title': 'Rules on this plan',
  'plan.rules.hint': 'Untick one to see the calendar without it. Nothing is saved — it only changes what you are looking at.',
  'plan.rules.none': 'No rules yet. Every day is the base plan.',
  'plan.rules.inactive': 'off',
  'plan.rules.previewing': 'Previewing without {n} rule(s).',
  'plan.rules.restore': 'Put them back',
  'plan.metric.covers': 'Covers',
  'plan.metric.revenue': 'Revenue',
  'plan.metric.avg_spend': 'Average spend',
  'plan.metric.occupancy': 'Occupancy',
  'plan.day.mon': 'Mon',
  'plan.day.tue': 'Tue',
  'plan.day.wed': 'Wed',
  'plan.day.thu': 'Thu',
  'plan.day.fri': 'Fri',
  'plan.day.sat': 'Sat',
  'plan.day.sun': 'Sun',
  'plan.day.close': 'Close',
  'plan.day.loading': 'Working out this day...',
  'plan.day.resolved': 'What this day does, and why',
  'plan.day.lastYear': 'Last year',
  'plan.day.covers': '{n} covers',
  'plan.day.noHistory': 'No comparable day on record. Nothing is guessed here.',
  'plan.day.suggest': 'Consider {price} — about {pct}% more',
  'plan.day.suggestHint': 'a suggestion, applied by nobody until you do',
  'plan.day.sittings': 'Sittings ({n})',
  'plan.day.closedDay': 'Closed — no sittings on this day.',
  'plan.day.seats': '{n} seats',
  'plan.day.booked': '{n} booking(s) on this day',
  'plan.day.bookedHint': 'These have been quoted a price. Changing the plan will not reprice them.',
  'plan.day.pax': '{n} guests',
  'plan.field.adultPrice': 'Adult price',
  'plan.field.childPrice': 'Child price',
  'plan.field.start': 'Service starts',
  'plan.field.end': 'Service ends',
  'plan.field.length': 'Sitting length',
  'plan.field.gap': 'Turnaround gap',
  'plan.field.seats': 'Seats per sitting',
  'plan.field.closed': 'Closed',
};

export const fr = {
  // --- Full-screen floor plan ----------------------------------------------
  'buffet.plan.apply': 'Enregistrer le plan',
  'buffet.plan.discardTitle': 'Abandonner ces modifications du plan ?',
  'buffet.plan.discardBody': 'Les tables déplacées et les stations posées dans cette fenêtre seront perdues. Le plan enregistré reste inchangé.',
  'buffet.plan.discardConfirm': 'Abandonner',
  'buffet.plan.keepEditing': 'Continuer à modifier',
  'buffet.plan.previewHint': 'Aperçu — utilisez Agrandir pour déplacer les tables et poser les plats.',
  'buffet.plan.expand': 'Agrandir',
  'buffet.plan.collapse': 'Fermer',
  'buffet.plan.fullTitle': 'Plan de salle et stations',
  'buffet.plan.fullHint': 'Faites glisser une table pour la déplacer ; cliquez un plat à droite pour le poser sur le plan. Rien n’est conservé tant que vous n’avez pas cliqué sur Enregistrer le plan.',
  // --- The two-phase wizard shell ------------------------------------------
  'buffet.wiz.phase1': 'Configuration du buffet',
  'buffet.wiz.phase2': 'Paramètres avancés',
  'buffet.wiz.lockedHint': 'Enregistrez d’abord le buffet — il n’y a rien à paramétrer tant qu’il n’existe pas.',
  'buffet.wiz.subStepOf': 'Configuration {n} sur {total}',
  'buffet.wiz.toAdvance': 'Paramètres avancés',
  'buffet.wiz.saveToContinue': 'Enregistrer et continuer',

  // --- The run calendar down the left of setup -----------------------------
  'buffet.cal.title': 'Dates de service',
  'buffet.cal.sub': '{n} jour(s) seront ouverts à l’enregistrement.',
  'buffet.cal.empty': 'Aucune date choisie pour l’instant.',
  'buffet.cal.emptyHint': 'Indiquez une première et une dernière date dans Nom, dates et services : les jours apparaîtront ici.',
  'buffet.cal.emptyHintSaved': "Ce buffet n'est encore programmé à aucune date. Indiquez une première et une dernière date dans Nom, dates et services, ou ouvrez-le sur un jour depuis Buffets ouverts.",
  'buffet.cal.legendOpened': 'Déjà ouvert',
  'buffet.cal.legendRunning': 'En service',
  'buffet.cal.dayOpened': 'Déjà ouvert ce jour-là — les clients peuvent réserver.',
  'buffet.cal.dayRunning': 'En service en ce moment.',
  'buffet.cal.countOpened': 'jours déjà ouverts',
  'buffet.cal.legendHoliday': 'Jour férié',
  'buffet.cal.noHolidays': 'Aucun jour férié ni fête sur cette période.',
  'buffet.cal.holidaysUnavailable': 'Le calendrier des fêtes n’a pas pu être chargé : les jours fériés ne sont pas signalés ici.',
  'buffet.cal.legendObservance': 'Fête observée',
  'buffet.cal.observance': 'observée',
  'buffet.cal.approxMark': '±1 jour',
  'buffet.cal.approxHint': 'Confirmée localement peu avant le jour même : la date peut varier d’un jour.',
  'buffet.cal.legendWeekend': 'Week-end',
  'buffet.cal.holidaysInRange': 'Jours fériés et fêtes sur cette période ({n})',
  'buffet.cal.publicHoliday': 'férié',
  'buffet.cal.legendPlanned': 'Prévu',
  'buffet.cal.legendSet': 'Programmé',
  'buffet.cal.dayPlanned': 'Prévu — c’est l’enregistrement du buffet qui ouvre ce jour.',
  'buffet.cal.daySet': 'Le buffet est programmé ce jour-là.',
  'buffet.cal.daySkipped': 'Exclu du service — cliquez pour le rétablir.',
  'buffet.cal.dayCloses': 'Ouvert aujourd’hui — fermé à l’enregistrement, hors de la règle',
  'buffet.cal.notYetOpened': 'Pas encore ouvert — c’est l’enregistrement du buffet qui le place sur ces jours.',

  // --- Month view (Open Buffets) -------------------------------------------
  'buffet.month.prev': 'Mois précédent',
  'buffet.month.next': 'Mois suivant',
  'buffet.month.expand': 'Agrandir le calendrier',
  'buffet.month.shrink': 'Réduire le calendrier',
  'buffet.month.jumpToday': 'Aller à aujourd’hui',
  'buffet.month.willOpen': 'S’ouvrira à l’enregistrement de cette répétition',
  'buffet.month.legendOpen': 'Ouvert ({n})',
  'buffet.month.legendLive': 'En cours ({n})',
  'buffet.month.legendRepeat': 'Cette répétition ({n})',

  // --- Planner calendar chrome (shared by every buffet calendar) -----------
  'buffet.cal.countOpen': 'jours ouverts',
  'buffet.cal.countHolidays': 'jours fériés',
  'buffet.cal.countWeekends': 'week-ends',
  'buffet.cal.legendToday': 'Aujourd’hui',
  'buffet.cal.range': 'du {from} au {to}',

  // --- Step 2: advance settings -------------------------------------------
  'buffet.adv.intro': 'Réglages facultatifs qui s’ajoutent au buffet que vous venez de configurer. La tarification à l’avance est active ; les deux autres volets sont en cours de construction — le buffet fonctionne sans aucun d’eux.',
  'buffet.adv.comingSoon': 'Rien à régler ici pour l’instant.',
  'buffet.adv.pricing.title': 'Paramètres de tarification à l’avance',
  'buffet.adv.pricing.blurb': 'Les jours qui ne sont pas ordinaires. Ce que chaque jour férié et chaque week-end a réellement attiré dans cette succursale ces dernières années, et combien facturer en plus du prix de l’étape 1.',

  // Advance pricing: the footfall tables, and the uplift they lead to.
  'buffet.adv.hol.title': 'Jours fériés compris dans cette période',
  'buffet.adv.hol.blurb': 'Ce que chacun a attiré ici sur les {n} dernières années — à la date où il est réellement tombé, car la plupart se déplacent. Cochez ceux qui méritent un prix plus élevé.',
  'buffet.adv.we.title': 'Week-ends compris dans cette période',
  'buffet.adv.hol.inRun': '{n} dans cette période',
  'buffet.adv.we.inRun': '{n} samedis et dimanches dans cette période',
  'buffet.adv.pricedN': '{n} tarifé(s)',
  'buffet.adv.nonePriced': 'Aucun tarif défini',
  'buffet.adv.backToCards': 'Retour aux tarifs avancés',
  'buffet.adv.closeCard': 'Fermer',
  'buffet.adv.we.blurb': 'La même question pour les samedis et les dimanches : ce qu’un week-end moyen a attiré ici chacune des {n} dernières années.',
  'buffet.adv.baseline': 'Un jour de semaine ordinaire nourrit environ {n} convives ici, sur {days} jours de service.',
  'buffet.adv.baselineNone': 'L’historique est insuffisant pour dire à quoi ressemble un jour ordinaire ici ; les chiffres ci-dessous se lisent donc seuls.',
  'buffet.adv.baseIs': 'L’étape 1 facture {price} par personne.',
  'buffet.adv.noBase': 'Indiquez un prix adulte à l’étape Tarification pour voir ce que cela donne.',
  'buffet.adv.colHoliday': 'Jour férié',
  'buffet.adv.colWeekend': 'Jour',
  'buffet.adv.colAvg': 'Moyenne sur {n} ans',
  'buffet.adv.colUplift': 'Prix ce jour-là',
  'buffet.adv.moves': 'change de date chaque année',
  'buffet.adv.publicHoliday': 'jour férié',
  'buffet.adv.observance': 'fête observée',
  'buffet.adv.noFigures': 'aucun chiffre',
  'buffet.adv.notObserved': 'non observé',
  'buffet.adv.vsOrdinary': '{pct} par rapport à un jour ordinaire',
  'buffet.adv.inRange': '{n} dans cette période',
  'buffet.adv.daysMeasured': '{n} jours',
  'buffet.adv.bookingsN': '{n} réservations',
  'buffet.adv.soldN': '{n} vendus à la caisse',
  'buffet.adv.bulkLead': 'Augmenter les lignes cochées de',
  'buffet.adv.apply': 'Appliquer aux {n} cochées',
  'buffet.adv.clearAll': 'Effacer toutes les hausses',
  'buffet.adv.clearOne': 'Facturer le prix ordinaire ce jour-là',
  'buffet.adv.tickAll': 'Cocher toutes les lignes',
  'buffet.adv.modePct': 'Un pourcentage appliqué au prix normal',
  'buffet.adv.modeSet': 'Un nouveau prix fixe pour ce jour, à la place du prix normal',
  'buffet.adv.newPrice': 'Nouveau prix',
  'buffet.adv.normalIs': 'Prix normal {price}',
  'buffet.adv.normalUnset': 'Pas encore de prix normal — renseignez le prix adulte à l’étape Tarifs',
  'buffet.adv.wasPrice': 'au lieu de {price}',
  'buffet.adv.onNormal': 'sur {price}',
  'buffet.adv.bulkLeadSet': 'Fixer les lignes cochées à',
  'buffet.adv.upliftLabel': 'Combien en plus',
  'buffet.adv.summary': '{n} hausses sont définies. Elles sont enregistrées comme règles de prix de ce buffet : la caisse, la page de réservation et chaque devis les appliquent le jour venu.',
  'buffet.adv.loading': 'Lecture des {n} dernières années…',
  'buffet.adv.failed': 'L’historique de fréquentation n’a pas pu être lu ; les tableaux ci-dessous sont donc sans historique. Les hausses fonctionnent toujours — vous les fixez au jugement plutôt que sur des chiffres.',
  'buffet.adv.noHolidays': 'Aucun jour férié ne tombe dans cette période.',
  'buffet.adv.needDates': 'Indiquez les dates de service à l’étape 1 : les jours fériés et les week-ends qu’elles contiennent seront listés ici avec ce qu’ils ont attiré auparavant.',
  'buffet.adv.fixedWarn': 'Le prix fixe est activé : aucune règle ne peut modifier le prix — ce qui est défini ici est enregistré mais jamais facturé.',
  'buffet.adv.useDynamic': 'Passer à la tarification dynamique',
  'buffet.adv.stacks': 'Il tombe un {day} : cette hausse-là s’ajoute à celle-ci.',
  'buffet.adv.dow.5': 'Samedi',
  'buffet.adv.dow.6': 'Dimanche',
  'buffet.adv.menu.title': 'Paramètres de choix du menu à l’avance',
  'buffet.adv.menu.blurb': 'Ce qu’un client peut choisir en réservant à l’avance : quels buffets sont proposés, et à partir de quand le choix est figé pour la cuisine.',
  'buffet.adv.capacity.title': 'Paramètres de capacité à l’avance',
  'buffet.adv.capacity.blurb': 'La part de la salle que les réservations anticipées peuvent occuper : places gardées pour les passages spontanés, et règles de libération par service.',

  // --- Step 1: which dates the buffet should be opened on ------------------
  'buffet.dates.label': 'Dates de service',
  'buffet.dates.from': 'Première date',
  'buffet.dates.to': 'Dernière date',
  'buffet.dates.hint': 'Facultatif — laissez vide pour enregistrer le modèle maintenant et choisir les dates plus tard dans Open Buffets.',
  'buffet.dates.willOpenOf': 'L’enregistrement ouvrira ce buffet sur {n} des {span} jour(s) de cette période.',
  'buffet.dates.noneLeft': 'Rien ne serait ouvert — tous les jours de cette période sont exclus.',
  'buffet.dates.runFor': 'Durée',
  'buffet.dates.preset.week': '1 semaine',
  'buffet.dates.preset.fortnight': '2 semaines',
  'buffet.dates.preset.month': '1 mois',
  'buffet.dates.preset.quarter': '3 mois',
  'buffet.dates.preset.halfYear': '6 mois',
  'buffet.dates.onDays': 'Jours de service',
  'buffet.dates.everyDay': 'Tous les jours',
  'buffet.dates.noWeekends': 'Sans le week-end',
  'buffet.dates.weekendsOnly': 'Week-end seulement',
  'buffet.dates.dow.0': 'Lun',
  'buffet.dates.dow.1': 'Mar',
  'buffet.dates.dow.2': 'Mer',
  'buffet.dates.dow.3': 'Jeu',
  'buffet.dates.dow.4': 'Ven',
  'buffet.dates.dow.5': 'Sam',
  'buffet.dates.dow.6': 'Dim',
  'buffet.dates.skipHolidays': 'Exclure les {n} jour(s) férié(s) de cette période',
  'buffet.dates.skipped': '{n} date(s) exclue(s)',
  'buffet.dates.clearSkipped': 'Toutes les rétablir',
  'buffet.dates.putBack': 'Rétablir cette date',
  'buffet.dates.clickHint': 'Cliquez sur un jour du calendrier pour l’exclure du service ou le rétablir.',
  'buffet.dates.savedNotOpened': 'Le buffet a été enregistré, mais ces dates n’ont pas pu être ouvertes : {error}',
  'buffet.dates.partlyOpened': 'Le buffet a été enregistré et ouvert sur {opened} jour(s) sur {total}. Les autres n’ont pas pu être ouverts : {error}',
  'buffet.dates.willClose': 'L’enregistrement fermera aussi {n} jour(s) déjà ouvert(s) que ces jours ne couvrent plus.',
  'buffet.dates.cantClose': '{n} d’entre eux restent ouverts — service effectué ou en cours.',
  'buffet.dates.someKept': 'Le buffet est enregistré et {closed} jour(s) fermé(s), mais {kept} n’ont pas pu l’être : {error}',
  'buffet.del.button': 'Supprimer',
  'buffet.del.title': 'Supprimer ce modèle définitivement — possible uniquement s’il n’a jamais vendu de couvert ni servi',
  'buffet.del.titleLive': 'En service actuellement — clôturez le service avant de le supprimer',
  'buffet.del.confirmTitle': 'Supprimer « {name} » ?',
  'buffet.del.confirmBody': 'Le modèle, sa carte et ses tarifs sont supprimés définitivement. Cette action est irréversible.',
  'buffet.del.confirmWithDates': 'Le modèle, sa carte et ses tarifs sont supprimés définitivement, ainsi que les {n} date(s) où il est ouvert. Cette action est irréversible.',
  'buffet.del.confirmCta': 'Supprimer définitivement',
  'buffet.del.runningTitle': 'Il est en service actuellement',
  'buffet.del.runningBody': '« {name} » a des clients au comptoir. Clôturez le service, puis il pourra être supprimé.',
  'buffet.del.failedTitle': 'Suppression impossible',
  'buffet.del.failedBody': 'Le buffet n’a pas été supprimé.',

  // --- Step 4: what each sitting charges -----------------------------------
  'buffet.slotPrice.title': 'Prix par service',
  'buffet.slotPrice.titleFixed': 'Prix fixe pour chaque service',
  'buffet.slotPrice.hint': 'Une ligne par service défini à l’étape 1. Chaque service démarre au prix par personne du buffet ci-dessus — modifiez une ligne et ce service se vend à son propre prix. Videz une case pour revenir au prix du buffet.',
  'buffet.slotPrice.noSlots': 'Aucun service pour l’instant. Activez les services à l’étape 1 pour les tarifer un par un.',
  'buffet.seatmap.perSitting': '{seats} convives par service',
  'buffet.seatmap.acrossSittings': '{total} sur {n} services',
  'buffet.seatmap.enough': 'suffisant pour les {covers} prévus',
  'buffet.seatmap.short': 'insuffisant pour les {covers} prévus',
  'buffet.slotPrice.slotOff': 'non vendu',
  'buffet.slotPrice.colCharges': 'Le convive paie',
  'buffet.slotPrice.ownTag': 'prix propre',
  'buffet.slotPrice.kidsShort': 'enfants {price}',
  'buffet.slotPrice.taxIncl': '{names} comprise(s)',
  'buffet.slotPrice.taxPlus': 'plus {names}',
  'buffet.slotPrice.dynamicNote': 'Ce sont les montants de départ de chaque service. Les règles de tarification dynamique peuvent encore les modifier — choisissez Prix fixe ci-dessus pour les facturer tels quels.',

  // --- Étape 4 : taxe sur le billet ------------------------------------
  'buffet.tax.title': 'Taxe sur le billet',
  'buffet.tax.excl': 'Prix hors taxe',
  'buffet.tax.incl': 'Prix taxe comprise',
  'buffet.tax.exclNote': 'Les prix ci-dessus sont ce que vous encaissez — la taxe s’ajoute par-dessus et le convive paie davantage.',
  'buffet.tax.inclNote': 'Les prix ci-dessus sont ce que le convive paie — la taxe y est déjà comprise et apparaît détaillée sur l’addition.',
  'buffet.tax.pickIncl': 'Quelle taxe est déjà comprise dans le prix ?',
  'buffet.tax.pickExcl': 'Quelle taxe s’ajoute par-dessus ?',
  'buffet.tax.compound': '(en cascade)',
  'buffet.tax.noneTicked': 'Aucune taxe cochée — les prix par personne ci-dessus sont facturés tels quels.',
  'buffet.tax.noRates': 'Aucun taux de taxe n’est encore paramétré pour ce restaurant : il n’y a rien à cocher.',
  'buffet.tax.setUp': 'Paramétrer les taux de taxe →',
  'buffet.tax.adultPays': 'Un adulte paie',
  'buffet.tax.kidPays': 'Un enfant paie',
  'buffet.tax.breakdown': '= {net} + {tax} de taxe',
  'buffet.tax.rulesCarry': 'Les prix fixés par les règles tarifaires portent les mêmes taxes.',

  'buffet.sit.title': 'Services',
  'buffet.sit.hint': "Vendez cette plage comme un seul service, ou comme une heure de début toutes les quelques minutes.",
  'buffet.sit.one': 'Un seul service',
  'buffet.sit.many': 'Services',
  'buffet.sit.gap': 'Un service commence toutes les',
  'buffet.sit.length': 'et dure',
  'buffet.sit.min': '{n} min',
  'buffet.sit.hr': '{n} h',
  'buffet.sit.count': '{n} services par jour, de {first} à {last}.',
  'buffet.sit.none': "Un service de {n} minutes ne tient pas entre {from} et {to} — raccourcissez le service ou élargissez la plage de service.",
  'buffet.sit.colTime': 'Service',
  'buffet.sit.colAdult': 'Prix adulte',
  'buffet.sit.colChild': 'Prix enfant',
  'buffet.sit.colSeats': 'Places',
  'buffet.sit.colOn': 'Servi',
  'buffet.sit.anySeats': 'Couverts du jour',
  'buffet.sit.turnOff': 'Non servi',
  'buffet.sit.turnOn': 'Servir celui-ci',
  'buffet.sit.blankHint': "Laissé vide, un service est vendu au prix du buffet et puise dans les couverts du jour.",

  'buffet.guests.title': 'Convives',
  'buffet.guests.adults': 'Adultes',
  'buffet.guests.children': 'Enfants',
  'buffet.guests.covers': 'Couverts prévus',

  'buffet.sit.pick': 'Choisissez votre service',
  'buffet.sit.pickHint': "Chaque service vous réserve la table pendant toute la durée indiquée.",
  'buffet.sit.full': 'Complet',
  'buffet.sit.seatsLeft': '{n} places restantes',
  'buffet.sit.seatLeft': '1 place restante',
  'buffet.sit.perAdult': '/adulte',

  'plan.list.title': 'Planificateur de buffet',
  'plan.list.sub': 'Un plan sur une longue période, modifié par des règles — aucun jour n’est configuré deux fois.',
  'plan.list.loading': 'Chargement des plans...',
  'plan.list.rules': '{n} règle(s)',
  'plan.list.emptyTitle': 'Aucun plan pour l’instant',
  'plan.list.emptyBody': 'Vos buffets fonctionnent toujours exactement comme avant — rien ici ne les a arrêtés. Le plan est la nouvelle façon de les configurer : un seul plan sur une longue période, modifié par des règles, au lieu d’une fiche pour chaque jour. Le transfert des buffets de cet établissement se fait une seule fois, par votre administrateur RestoBOXX, car chaque règle de prix doit d’abord être relue par une personne. En attendant, continuez dans la Liste des buffets.',
  'plan.list.emptyCta': 'Aller à la liste des buffets',
  'plan.calendar.title': 'Planificateur de buffet',
  'plan.calendar.sub': 'Chaque jour est calculé à partir du plan et de ses règles.',
  'plan.calendar.runs': 'Du {range}. Rien n’est enregistré par jour — modifiez une règle et tous les jours suivent.',
  'plan.calendar.back': 'Retour',
  'plan.calendar.prev': 'Mois précédent',
  'plan.calendar.next': 'Mois suivant',
  'plan.calendar.closed': 'Fermé',
  'plan.calendar.covers': '{n} couverts',
  'plan.calendar.noHistory': 'Pas d’historique',
  'plan.rules.title': 'Règles de ce plan',
  'plan.rules.hint': 'Décochez-en une pour voir le calendrier sans elle. Rien n’est enregistré : cela ne change que votre affichage.',
  'plan.rules.none': 'Aucune règle pour l’instant. Chaque jour suit le plan de base.',
  'plan.rules.inactive': 'inactive',
  'plan.rules.previewing': 'Aperçu sans {n} règle(s).',
  'plan.rules.restore': 'Les rétablir',
  'plan.metric.covers': 'Couverts',
  'plan.metric.revenue': 'Chiffre d’affaires',
  'plan.metric.avg_spend': 'Panier moyen',
  'plan.metric.occupancy': 'Taux de remplissage',
  'plan.day.mon': 'Lun',
  'plan.day.tue': 'Mar',
  'plan.day.wed': 'Mer',
  'plan.day.thu': 'Jeu',
  'plan.day.fri': 'Ven',
  'plan.day.sat': 'Sam',
  'plan.day.sun': 'Dim',
  'plan.day.close': 'Fermer',
  'plan.day.loading': 'Calcul de cette journée...',
  'plan.day.resolved': 'Ce que fait cette journée, et pourquoi',
  'plan.day.lastYear': 'L’an dernier',
  'plan.day.covers': '{n} couverts',
  'plan.day.noHistory': 'Aucune journée comparable enregistrée. Rien n’est inventé ici.',
  'plan.day.suggest': 'Envisagez {price} — environ {pct}% de plus',
  'plan.day.suggestHint': 'une suggestion, que personne n’applique tant que vous ne le faites pas',
  'plan.day.sittings': 'Services ({n})',
  'plan.day.closedDay': 'Fermé — aucun service ce jour-là.',
  'plan.day.seats': '{n} places',
  'plan.day.booked': '{n} réservation(s) ce jour-là',
  'plan.day.bookedHint': 'Un prix leur a été annoncé. Modifier le plan ne les retarifera pas.',
  'plan.day.pax': '{n} convives',
  'plan.field.adultPrice': 'Prix adulte',
  'plan.field.childPrice': 'Prix enfant',
  'plan.field.start': 'Début du service',
  'plan.field.end': 'Fin du service',
  'plan.field.length': 'Durée du service',
  'plan.field.gap': 'Battement',
  'plan.field.seats': 'Places par service',
  'plan.field.closed': 'Fermé',
};
